//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper, UserSession } from '../../helpers'

import { Activity, Enums } from '../../models/common'
import { OpOperator } from '../../models/core/op-operator'

import { TASK_SERVICE_NAME, TaskService } from '../../services/task'
import { SERVICES_MODULE_NAME } from './../../services'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $STATE_SERVICE_PROVIDER_NAME, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SystemService, SYSTEM_SERVICE_NAME } from '../../services/system'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

import { TaskController, TaskScope } from './tasks.controller'
import { TaskDetailsDirective } from './details/tasks-details.directive'
import { TaskCreateEditDirective } from './create-edit/tasks-create-edit.directive'
import { TaskStatusChangeComponent } from './status-change'


//#region Asset Imports

import * as TEMPLATE from './tasks.tpl.html'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'TaskController'
const DETAILS_DIRECTIVE_NAME: string = 'taskDetails'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'taskCreateEdit'
const MENU_INDEX: number = 7

const MODULE_NAME: string = 'simax.tasks'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Tasks'
const STATE_NAME: string = 'tasks'
const STATE_URL: string = '/tasks'

const TASK_STATUS_CHANGE_COMPONENT_NAME: string = 'taskStatusChange'
const DETAILS_COMPONENT_KEY = 'Task_IdTask'
const MENU_ITEM_NAME = 'tasks'

// #endregion


// #region Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    USER_SESSION_SERVICE_NAME,
    GRID_CONTEXT_MENU_SERVICE_NAME,
    TASK_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: TaskScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSessionService: UserSessionService,
        gridContextMenuService: GridContextMenuService,
        taskService: TaskService,
        systemService: SystemService
    ) => new TaskController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        userSessionService,
        gridContextMenuService,
        taskService,
        systemService,
        TaskService.REFERENCE_TYPE,
        TaskService.SIMAX_MODULE_NAME
    )])


module.directive(DETAILS_DIRECTIVE_NAME, [() => new TaskDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new TaskCreateEditDirective()])
module.component(TASK_STATUS_CHANGE_COMPONENT_NAME, new TaskStatusChangeComponent())


module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: DETAILS_COMPONENT_KEY,
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.TASK_LIST)
                && !loggedOperator.hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.TASKS),
                    MENU_ITEM_NAME,
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// #endregion

export default MODULE_NAME
